import { render } from "./AddModePaiementModal.vue?vue&type=template&id=3c1c80e9&ts=true"
import script from "./AddModePaiementModal.vue?vue&type=script&lang=ts"
export * from "./AddModePaiementModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__